import * as Sentry from '@sentry/react'
import type { SchoolAccount } from '@common/models/account/school/school-account.modl'

/** 学校アカウント情報を Sentry タグに反映する */
export function syncSentrySchoolTags(account: SchoolAccount | null): void {
  const scope = Sentry.getCurrentScope()

  if (!account) {
    scope.setTag('school_name', undefined)
    scope.setTag('school_id', undefined)
    return
  }

  scope.setTag('school_name', account.schoolName)
  scope.setTag('school_id', account.id)
}
